import { render, staticRenderFns } from "./clause-tip-zgy.vue?vue&type=template&id=2b769155&scoped=true&"
import script from "./clause-tip-zgy.vue?vue&type=script&lang=js&"
export * from "./clause-tip-zgy.vue?vue&type=script&lang=js&"
import style0 from "./clause-tip-zgy.vue?vue&type=style&index=0&id=2b769155&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b769155",
  null
  
)

export default component.exports